import { api } from "./api";
import Router from "next/router";
import { setLoadingBar } from "../ducks/siteData";
import { setUserData, setLoading } from "../ducks/signIn";

export function signInOrWillCreateAppleUser(token: string) {
  api
    .post("/auth/apple/token", { token })
    .then((response) => {
      if (response.data.willCreateAppleUser) {
        Router.push(`/register/addUsername?accountType=apple&token=${token}`);
      } else {
        setUserData(response.data);
        setLoading(false);
        Router.replace("/lobby");

        window.scrollTo(0, 0);
      }
    })
    .catch((e) => {
      setLoading(false);
      console.log("signInOrWillCreateAppleUser error", e);
    })
    .then(() => {
      setLoadingBar(false);
    });
}

export async function signInAppleWeb() {
  setLoadingBar(true);
  try {
    const data = await window.AppleID.auth.signIn();

    if (data.authorization) {
      signInOrWillCreateAppleUser(data.authorization.id_token);
    } else {
      setLoadingBar(false);
    }
  } catch (error) {
    setLoadingBar(false);
  }
}
